<template>
  <div>
    <!--    <h1>新页面</h1>-->
    <!-- 你的页面内容 -->
    <div>
      <!--     插入一个变量名-->
      <el-button @click="handleClick()">{{ name }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewPage',
  data() {
    return {
      // 你的数据
      name: '云企通'
    }
  },
  methods: {
    // 你的方法
    handleClick() {
      //弹框确认
      this.$confirm('确定要点击吗？', '提示', {})
    }
  }
}
</script>

<style scoped>
/* 你的样式 */
</style>